/**
 * Browser localStorage keys for aniOS workspace persistence.
 * Workspace state is scoped per authenticated user to avoid bleed on shared browsers.
 */

/** Legacy global key (pre user-scoping); migrated or removed on load/logout */
export const LEGACY_OS_STATE_KEY = "ani_os_state";

/** Prefix for per-user workspace state buckets */
export const OS_STATE_KEY_PREFIX = "ani_os_state:";

/**
 * Returns the localStorage key for a user's aniOS workspace snapshot.
 */
export function getOsStateStorageKey(userId: string): string {
  return `${OS_STATE_KEY_PREFIX}${userId}`;
}

/**
 * Removes the legacy global workspace state key.
 */
export function removeLegacyOsStateKey(): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(LEGACY_OS_STATE_KEY);
  } catch {
    // ignore
  }
}

/**
 * Clears persisted workspace state for a user (e.g. on logout).
 */
export function clearOsStateForUser(userId: string): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(getOsStateStorageKey(userId));
    removeLegacyOsStateKey();
  } catch {
    // ignore
  }
}
